export default __webpack_public_path__ + "static/media/twitter.04d7098a.svg";